import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useHighlight, useIsMounted, useIsVisible } from "@sportal/cdk";

import {
  getMarkedOptions,
  parseTokens,
} from "@sportal/lib/marked/parseMarkdown";

import { getSelectedLanguage } from "../../../i18n/language.selectors";
import { useHighlightContext } from "../HighlightContext/HighlightContext";

export const HelpSection = ({ section }) => {
  const { section: paramSection } = useParams();
  const navigate = useNavigate();

  const sectionRef = useRef(null);
  const checkIsMounted = useIsMounted();

  const language = useSelector(getSelectedLanguage).key;
  const mdOptions = getMarkedOptions(language);
  const { searchString, onHighlightDone, activeSection, updateActiveSections } =
    useHighlightContext();

  const { id, header, tokens } = section;

  const isVisible = useIsVisible(sectionRef);

  useEffect(() => {
    updateActiveSections(id, isVisible);
  }, [id, isVisible, updateActiveSections]);

  useEffect(() => {
    if (id === paramSection && activeSection !== id) {
      sectionRef.current.scrollIntoView({ block: "start" });
    }
    // updating activeSection will trigger useEffect,
    // but we need just check the condition here
    // eslint-disable-next-line
  }, [id, paramSection]);

  useEffect(() => {
    if (
      checkIsMounted() &&
      activeSection === id &&
      activeSection !== paramSection
    ) {
      navigate(`/help/${activeSection}`);
    }
  }, [id, activeSection, paramSection, checkIsMounted, navigate]);

  useHighlight(sectionRef, id, searchString, onHighlightDone);

  const headerHtml = parseTokens([header], mdOptions);
  const contentHtml = parseTokens(tokens, mdOptions);

  return (
    <section id={id} ref={sectionRef} className={"help-section"}>
      <header dangerouslySetInnerHTML={{ __html: headerHtml }} />
      <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
    </section>
  );
};
